/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DefaultWebhookParams } from './DefaultWebhookParams';
import type { GoogleChatWebhookParams } from './GoogleChatWebhookParams';

export type CreateAlertingHookRequestDto = {
    externalHook: string;
    name: string;
    params?: (DefaultWebhookParams | GoogleChatWebhookParams);
    type: CreateAlertingHookRequestDto.type;
};

export namespace CreateAlertingHookRequestDto {

    export enum type {
        SLACK = 'SLACK',
        MAIL = 'MAIL',
        MS_TEAMS = 'MS_TEAMS',
        WEBHOOK = 'WEBHOOK',
    }


}
